import DOMPurify from 'dompurify';

export function sanitizeKnowledgeHubHtml(content: string): string {
  return DOMPurify.sanitize(content, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'target'],
    FORBID_TAGS: ['script', 'style'],
  });
}
